import { useSelector } from 'react-redux';

import env from '@travel/env';
import { getCurrency, getLanguage, getMarket } from '@travel/i18n';
import { getOmniClientId } from '@travel/traveler-core/utils/omni';
import { stringify } from '@travel/utils';

import paths from 'core/universalRouter/paths';

function useLogin() {
  const baseUrl = env('UNIVERSAL_OMNI_LOGIN_URL');
  const language = useSelector(getLanguage);
  const { marketCode } = useSelector(getMarket);
  const currency = useSelector(getCurrency);

  const onClickLogin = (callbackUrl?: string, options?: { preserveI18nSettings?: boolean }) => {
    // save omni callback url to localStorage
    if (callbackUrl) {
      localStorage.setItem('omniCallbackUrl', callbackUrl);
    }


    const params: Record<string, string> = {
      client_id: getOmniClientId(marketCode),
      redirect_uri: paths.auth.pathResolver(window.location.origin),
      scope: 'openid profile email',
      response_type: 'code',
      ui_locales: language,
      r10_audience: 'rid',
      max_age: '0',
    };

    // Only add state parameter if explicitly requested (for LoginOrGuestPage flow)
    if (options?.preserveI18nSettings) {
      // Pass i18n settings with format: currency|language|market (e.g., "USD|en-us|usa")
      const stateValue = `${currency}|${language}|${marketCode}`;
      params.state = encodeURIComponent(stateValue);
    }

    // composed Omni url
    const paramsString = stringify(params);
    const composedUrl = `${baseUrl}?${paramsString}#/sign_in`;
    window.location.assign(composedUrl);
  };

  return { onClickLogin };
}

export default useLogin;
